export enum REAL_ESTATE_TYPE {
    RELEASE = 'RELEASE',
    VENTURE = 'VENTURE',
    COMMING_SOON = 'COMMING_SOON',
    SELECTED = 'SELECTED',
}

export enum REAL_ESTATE_TYPE_FILTER {
    ALL = 'ALL',
    RELEASE = 'RELEASE',
    VENTURE = 'VENTURE',
    COMMING_SOON = 'COMMING_SOON',
    SELECTED = 'SELECTED',
}
